export default __webpack_public_path__ + "static/media/page3Image2.5941fe32.png";